import React from 'react';
import Canvas from './Canvas';
import { URLS, IMGS } from '../constants';

const Hero = () => (
  <Canvas spanClass="span8" spacing={false}>
    <a href={ URLS.slideshow }>
      <div style={{ position: 'relative' }}>
        <img src={ IMGS.lionel_1bday } alt="Lionel First Birthday" />
      </div>
    </a>
  </Canvas>
);

export default Hero;


// WEBPACK FOOTER //
// ./src/components/Hero.js